import { filesMap } from 'sos-common/js/commonTypes/FormBaseStore.types';
import { FormBaseStore } from 'sos-common/js/commonTypes/FormBaseStore.types';
import { registersMap } from 'sos-common/js/commonTypes/FormBaseStore.types';
import { ValidationResult } from 'sos-common/js/commonTypes/validation.types';
import { doPost } from './fetch.service';

export type resultType = ValidationResult[];

export function doValidateByState(state: FormBaseStore<any>) {
  const { formModel, registers, files } = state;
  return doValidate(formModel, registers, files);
}

function doValidate(formModel: object, registries: registersMap, currentFiles: filesMap): Promise<ValidationResult[]> {
  const path = '/validate';

  const payload = {
    currentFiles,
    formModel,
    registries,
  };

  const body = JSON.stringify(payload);

  return doPost<resultType>(path, body, new Headers({ 'Content-Type': 'application/json' }))
    .then((response) => {
      if (response && Array.isArray(response)) {
        return response;
      } else {
        return [];
      }
    })
    .catch((err) => {
      console.error(err);
      return [];
    });
}
